var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercardWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 24,
    viewBox: "0 0 49 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 48,
    height: 23,
    rx: 3.5,
    stroke: "#DBDADE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5726_7252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1113 5.67261H27.8643V17.968H21.1113V5.67261Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5399 11.8204C21.5399 9.32227 22.6976 7.10644 24.4769 5.67266C23.1692 4.62996 21.5186 4 19.7178 4C15.4515 4 12 7.49741 12 11.8204C12 16.1433 15.4515 19.6408 19.7177 19.6408C21.5185 19.6408 23.1691 19.0109 24.4769 17.9681C22.6976 16.5561 21.5399 14.3186 21.5399 11.8204Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9749 11.8204C36.9749 16.1433 33.5234 19.6408 29.2572 19.6408C27.4564 19.6408 25.8058 19.0109 24.498 17.9681C26.2988 16.5344 27.4351 14.3186 27.4351 11.8204C27.4351 9.32227 26.2773 7.10644 24.498 5.67266C25.8057 4.62996 27.4564 4 29.2572 4C33.5234 4 36.9749 7.51918 36.9749 11.8204Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5726_7252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 16,
    fill: "white",
    transform: "translate(12 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardWalletIcon);
export default __webpack_public_path__ + "static/media/MastercardWalletIcon.cadd76eba120b29d8552024596dec275.svg";
export { ForwardRef as ReactComponent };